module.exports = __webpack_public_path__ + "img/52002754_L.a41a84a5.png";